// HKDSE Chinese Language Extended Mock Data
// 香港中學文憑考試 中國語文科 擴展模擬數據

export const hkdseChineseExtended = [
  // Chinese Language Paper 1 - Reading Comprehension & Classical Chinese
  {
    id: 16,
    name: 'HKDSE 中國語文 卷一 (閱讀理解)',
    nameEn: 'HKDSE Chinese Language Paper 1 (Reading)',
    nameCn: 'HKDSE 中国语文 卷一',
    nameJa: 'HKDSE 中国語 第一部',
    course: '香港中學文憑考試',
    duration: 150,
    totalQuestions: 30,
    passingScore: 50,
    category: 'language',
    difficulty: 'advanced',
    description: '測試中文閱讀理解、文言文理解和語文運用能力',
    modes: {
      examMode: { name: '考試模式', timeLimit: 150, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: '自習模式', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: '預測模式', timeLimit: 150, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "下列哪個詞語的讀音正確？",
        questionEn: "Which pronunciation is correct?",
        hasAudio: true,
        audioUrl: "/audio/chinese/pronunciation_1.mp3",
        options: ["載(zài)重", "載(zǎi)重", "載(zài)歌載舞", "記載(zài)"],
        correctAnswer: 0,
        explanation: "「載重」應讀作「zài」，表示承受重量。",
        explanationEn: "\"載重\" should be pronounced \"zài\", meaning to bear weight.",
        difficulty: "medium",
        topic: "語音知識"
      },
      {
        id: 2,
        question: "請聽詩句朗讀，選出正確的韻腳：",
        questionEn: "Listen to the poem and identify the rhyme:",
        hasAudio: true,
        audioUrl: "/audio/chinese/poem_rhyme_1.mp3",
        options: ["平聲韻", "仄聲韻", "入聲韻", "混合韻"],
        correctAnswer: 0,
        explanation: "這首詩使用平聲韻，韻腳字都是平聲調。",
        explanationEn: "This poem uses level tone rhyme.",
        difficulty: "hard",
        topic: "詩歌韻律"
      },
      {
        id: 3,
        question: "「君子之交淡如水」中「淡」字的含義是：",
        questionEn: "What does \"淡\" mean in this idiom?",
        hasAudio: true,
        audioUrl: "/audio/chinese/idiom_1.mp3",
        options: ["清淡無味", "平淡樸素", "清澈透明", "簡單容易"],
        correctAnswer: 1,
        explanation: "「淡」指平淡樸素，不追求功利。",
        explanationEn: "\"淡\" means simple and pure, not pursuing profit.",
        difficulty: "medium",
        topic: "成語理解"
      },
      {
        id: 4,
        question: "下列哪個句子使用了擬人修辭？",
        questionEn: "Which sentence uses personification?",
        hasAudio: true,
        audioUrl: "/audio/chinese/rhetoric_1.mp3",
        options: ["春風吹綠了大地", "花兒在風中跳舞", "雨後空氣清新", "太陽照耀大地"],
        correctAnswer: 1,
        explanation: "「花兒跳舞」賦予花兒人的動作。",
        explanationEn: "\"Flowers dancing\" gives human actions to flowers.",
        difficulty: "easy",
        topic: "修辭手法"
      },
      {
        id: 5,
        question: "古文「學而時習之，不亦說乎」中「說」讀作：",
        questionEn: "How is \"說\" pronounced in classical Chinese?",
        hasAudio: true,
        audioUrl: "/audio/chinese/classical_1.mp3",
        options: ["shuō", "yuè", "tuō", "shuì"],
        correctAnswer: 1,
        explanation: "古文中「說」通「悅」，讀「yuè」。",
        explanationEn: "In classical Chinese, \"說\" is pronounced \"yuè\".",
        difficulty: "hard",
        topic: "古文字音"
      }
      // Note: This is a sample of 5 questions. In practice, all 30 questions would be included.
    ]
  },

  // Chinese Language Paper 2 - Writing Skills
  {
    id: 17,
    name: 'HKDSE 中國語文 卷二 (寫作技巧)',
    nameEn: 'HKDSE Chinese Language Paper 2 (Writing)',
    nameCn: 'HKDSE 中国语文 卷二',
    nameJa: 'HKDSE 中国語 第二部',
    course: '香港中學文憑考試',
    duration: 150,
    totalQuestions: 30,
    passingScore: 50,
    category: 'language',
    difficulty: 'advanced',
    description: '測試中文寫作技巧、語法運用和表達能力',
    modes: {
      examMode: { name: '考試模式', timeLimit: 150, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: '自習模式', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: '預測模式', timeLimit: 150, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "下列標點符號使用正確的是：",
        questionEn: "Which punctuation usage is correct?",
        hasAudio: true,
        audioUrl: "/audio/chinese/punctuation_1.mp3",
        options: [
          "他問：「你去哪裡？」",
          "他問「你去哪裡？」",
          "他問：你去哪裡？",
          "他問，「你去哪裡？」"
        ],
        correctAnswer: 0,
        explanation: "直接引語前用冒號，引語用引號。",
        explanationEn: "Use colon before direct speech, enclose in quotation marks.",
        difficulty: "medium",
        topic: "標點符號"
      }
      // Additional questions would follow...
    ]
  },

  // Chinese Language Paper 3 - Literature Appreciation
  {
    id: 18,
    name: 'HKDSE 中國語文 卷三 (文學賞析)',
    nameEn: 'HKDSE Chinese Language Paper 3 (Literature)',
    nameCn: 'HKDSE 中国语文 卷三',
    nameJa: 'HKDSE 中国語 第三部',
    course: '香港中學文憑考試',
    duration: 150,
    totalQuestions: 30,
    passingScore: 50,
    category: 'language',
    difficulty: 'advanced',
    description: '測試中國文學作品賞析和理解能力',
    modes: {
      examMode: { name: '考試模式', timeLimit: 150, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: '自習模式', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: '預測模式', timeLimit: 150, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "聽唐詩朗誦，這首詩的主題是：",
        questionEn: "Listen to the Tang poem. What is its theme?",
        hasAudio: true,
        audioUrl: "/audio/chinese/tang_poem_1.mp3",
        options: ["思鄉", "送別", "詠物", "哲理"],
        correctAnswer: 1,
        explanation: "這是一首送別詩，表達離別之情。",
        explanationEn: "This is a farewell poem expressing parting emotions.",
        difficulty: "medium",
        topic: "詩歌主題"
      }
      // Additional questions would follow...
    ]
  },

  // Chinese Language Paper 4 - Practical Writing
  {
    id: 19,
    name: 'HKDSE 中國語文 卷四 (實用文寫作)',
    nameEn: 'HKDSE Chinese Language Paper 4 (Practical Writing)',
    nameCn: 'HKDSE 中国语文 卷四',
    nameJa: 'HKDSE 中国語 第四部',
    course: '香港中學文憑考試',
    duration: 150,
    totalQuestions: 30,
    passingScore: 50,
    category: 'language',
    difficulty: 'advanced',
    description: '測試實用文體寫作和應用文技巧',
    modes: {
      examMode: { name: '考試模式', timeLimit: 150, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: '自習模式', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: '預測模式', timeLimit: 150, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "聽書信格式說明，正式書信的稱謂應該：",
        questionEn: "Listen to letter format explanation. Formal letter salutation should:",
        hasAudio: true,
        audioUrl: "/audio/chinese/letter_format_1.mp3",
        options: ["頂格寫", "空兩格寫", "居中寫", "右對齊寫"],
        correctAnswer: 0,
        explanation: "正式書信的稱謂應該頂格書寫。",
        explanationEn: "Formal letter salutation should be written at the left margin.",
        difficulty: "easy",
        topic: "應用文格式"
      }
      // Additional questions would follow...
    ]
  },

  // Chinese Language Paper 5 - Comprehensive Skills
  {
    id: 20,
    name: 'HKDSE 中國語文 卷五 (綜合能力)',
    nameEn: 'HKDSE Chinese Language Paper 5 (Integrated Skills)',
    nameCn: 'HKDSE 中国语文 卷五',
    nameJa: 'HKDSE 中国語 第五部',
    course: '香港中學文憑考試',
    duration: 150,
    totalQuestions: 30,
    passingScore: 50,
    category: 'language',
    difficulty: 'advanced',
    description: '測試中文聽說讀寫綜合運用能力',
    modes: {
      examMode: { name: '考試模式', timeLimit: 150, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: '自習模式', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: '預測模式', timeLimit: 150, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "聽對話，說話者的語氣表達了：",
        questionEn: "Listen to the dialogue. The speaker's tone expresses:",
        hasAudio: true,
        audioUrl: "/audio/chinese/dialogue_tone_1.mp3",
        options: ["疑問", "肯定", "委婉", "強烈"],
        correctAnswer: 2,
        explanation: "說話者使用委婉的語氣表達建議。",
        explanationEn: "The speaker uses a gentle tone to express suggestions.",
        difficulty: "medium",
        topic: "語氣分析"
      }
      // Additional questions would follow...
    ]
  }
]; 